import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './App.css'
import { Home } from './pages/home/Home'
import { Layout } from './components/layout'
import { MainLayout } from './components/mainlayout'
import { Login } from './pages/login/Login'
import { useDispatch, useSelector } from 'react-redux'
import { AuthSliceMethods, getAuthState } from './redux/slices/authSlice'
import { Paths } from './paths'
import { AppDispatch } from './redux/root/root.store'
import { useEffect } from 'react'
import { Reservoir } from './components/Reservoir/ui'
import AnimalPage from './pages/animal'
import AnimalSalePage from './pages/animalSale'
import AnimalKrcPage from './pages/animalkrc'
import PlantsSalePage from './pages/salesplants'
import PlantsProductionPage from './pages/productionplants'
import NurseryPage from './pages/nursery'
import SuppliersPage from './pages/suppliers'
import BreedinPlantsPage from './pages/breedinplants'
import BreedinFarmsPage from './pages/breedinfarm'
import EconomicActivityPage from './pages/economicactivity'
import CameraPage from './pages/camera'
import { BreedingFarms } from './pages/admin/breedingFarms/BreedingFarms'
import { FarmOwners } from './pages/admin/farmOwners/FarmOwners'
import { BreedingFarmStatus } from './pages/admin/handbooks/breedingFarmStatus/BreedingFarmStatus'
import { Direction } from './pages/admin/handbooks/direction/Direction'
import { UnitMeasurement } from './pages/admin/handbooks/unitMeasurement/UnitMeasurement'
import { TypeProduct } from './pages/admin/handbooks/typeProduct/TypeProduct'
import { AnimalBreed } from './pages/admin/handbooks/animalBreed/AnimalBreed'
import { TypeAnimal } from './pages/admin/handbooks/typeAnimal/TypeAnimal'
import { Users } from './pages/admin/users/Users'
import { Roles } from './pages/admin/Roles/Roles'
import { Population } from './pages/admin/population/Population'
import { Products } from './pages/admin/products/Products'
import { Reservoirs } from './pages/admin/reservoirs/Reservoirs'
import { ReservoirsHistory } from './pages/admin/reservoirsHistory/ReservoirsHistory'
import { ChangePasswordPage } from './pages/login/ChangePasswordForm'
import { AnimalBreedFarmTypes } from './pages/admin/handbooks/animalBreedFarmType/AnimalBreedFarmTypes'
import ReservoirStatisticsWrapper from './components/Reservoir/ui/mapcomponent/ReservoirStatisticsPage'
import AllChartsPage from './pages/AllCharts'
import PersonalPage from './pages/Personal'
import MovablePage from './pages/MovablePage'
import FinancePage from './pages/financepage'
import ImmovablePage from './pages/immovablepage'
import { GeneralData } from './components/generaldata'
import AgriculturalmachineryPage from './pages/Agriculturalmachinerypage'
import PesticidesPage from './pages/pesticidespage'
import { Mts } from './pages/admin/mechanization/mts/Mts'
import { EntityTypes } from './pages/admin/handbooks/mechanization/entityTypes/EntityTypes'
import {
  EconomicActivityTypes
} from './pages/admin/handbooks/mechanization/economicActivityTypes/EconomicActivityTypes'
import  HeatmapbytypesofanimalsPage  from "./pages/Grossharvestofproductspages/Heatmapbytypesofanimals"
import { AgroculturalCooperative } from './pages/admin/mechanization/agriculturalCooperative/AgroculturalCooperative'
import { FinancialIndicators } from './pages/admin/financialIndicators/FinancialIndicators'
import { TerritorialUnits } from './pages/admin/handbooks/territorialUnits/TerritorialUnits'
import MTSPage from './pages/mtspage'
import CooperativesPage from './pages/cooperativespage'
import TLSPage from './pages/tlcpage'
import { Governments } from './pages/admin/handbooks/government/Governments'
import { Departments } from './pages/admin/handbooks/departments/Departments'
import { Personel } from './pages/admin/personnel/Personel'
import { TypeTransport } from './pages/admin/handbooks/typeTransport/TypeTransport'
import { Positions } from './pages/admin/handbooks/positions/Position'
import { TransportCategory } from './pages/admin/handbooks/transportCategory/TransportCategory'
import { LeasingOperator } from './pages/admin/handbooks/mechanization/leasingOperator/LeasingOperator'
import { RealEstateRegister } from './pages/admin/realEstate/RealEstateRegister'
import { TypeObjects } from './pages/admin/handbooks/typeObjects/TypeObject'
import { TypeEstatePurposeObject } from './pages/admin/handbooks/typeEstatePurposeObject/TypeEstatePurposeObject'
import { RealEstateConditions } from './pages/admin/handbooks/realEstateConditions/RealEstateConditions'
import { RealEstateLangCategories } from './pages/admin/handbooks/realEstateLangCategories/RealEstateLangCategories'
import { LeasingRegister } from './pages/admin/mechanization/leasingRegister/LeasingRegister'
import { MechanizationInfo } from './pages/admin/mechanization/info/MechanizationInfo'
import { TransportStatus } from './pages/admin/handbooks/transportStatus/TransportStatus'
import { LeasingProject } from './pages/admin/handbooks/mechanization/leasingProject/LeasingProject'
import { TransportRegister } from './pages/admin/mechanization/transport/Transport'
import TLCOrganicPage from './pages/Grossharvestofproductspages/TLC'
import NeedsofthepopulationPage from './pages/Grossharvestofproductspages/Needsofthepopulation'
import StorageAnaliticalPage from './pages/Grossharvestofproductspages/Storage'
import LargeprocessorsPage from './pages/Grossharvestofproductspages/Largeprocessors'
import ImportExportPage from './pages/Grossharvestofproductspages/ImportExport'
import NotFoundPage from './pages/errors/NotFoundPage'
import LeasingPage from './pages/leasingpage'
import KurultaiPage from './pages/KurultaiPage'
import Mineralfertilizersupplierspage from './pages/Mineralfertilizersupplierspage'
import FeedingPage from './pages/Feedingpage'
import FertilizationCerealsPage from './pages/FertilizationCerealspage'
import { OwnershipTypes } from './pages/admin/handbooks/mechanization/ownershipTypes/OwnershipTypes'
import { FertilizerCategory } from './pages/admin/handbooks/chemicalization/fertilizerСategory/FertilizerCategory'
import { TypesOfFertilizers } from './pages/admin/handbooks/chemicalization/typesOfFertilizers/TypesOfFertilizers'
import { OwnershipForms } from './pages/admin/handbooks/mechanization/ownershipForms/OwnershipForms'
import { Company } from './pages/admin/chemicalization/company/Company'
import { TypesOfPesticides } from './pages/admin/handbooks/chemicalization/typesOfPesticides/TypesOfPesticides'
import { Pesticides } from './pages/admin/chemicalization/pesticides/Pesticides'
import { СompanyWarehouses } from './pages/admin/chemicalization/companyWarehouses/CompanyWarehouses'
import { Stock } from './pages/admin/chemicalization/stock/Stock'
import {
  TypesOfAgriculturalCrops
} from './pages/admin/handbooks/chemicalization/typesOfAgriculturalCrops/TypesOfAgriculturalCrops'
import { TypeOfProductCategory } from './pages/admin/handbooks/chemicalization/productCategory/typeOfProductCategory'
import { TypeOfProduct } from './pages/admin/handbooks/chemicalization/product/typeOfProduct'
import { GeneralTypeProduct } from './pages/admin/handbooks/generalTypeOfProduct/GeneralTypeProduct'
import { MovableProperty } from './pages/admin/movableProperty/MovableProperty'
import { FertilizerUsage } from './pages/admin/chemicalization/fertilizerUsage/FertilizerUsage'
import { WinterCerealFertilizer } from './pages/admin/chemicalization/winterCerealFertilizer/WinterCerealFertilizer'
import { ExecutionStatus } from './pages/admin/handbooks/kurultai/executionStatus/ExecutionStatus'
import { QuestionCategory } from './pages/admin/handbooks/kurultai/questionCategory/QuestionCategory'
import { KurultaiRegister } from './pages/admin/kurultaiRegister/KurultaiRegister'
import MainAdminPage from './pages/admin/mainAdminPage/MainAdminPage'
import {
  VeterinaryProductCategory
} from './pages/admin/handbooks/veterinary/veterinaryProductCategory/VeterinaryProductCategory'
import { TypeVeterinaryProduct } from './pages/admin/handbooks/veterinary/veterinaryProduct/typeOfVeterinaryProduct'
import { Certificate } from "./pages/admin/handbooks/organic/certificate/Certificate";
import { IndustryType } from "./pages/admin/handbooks/organic/industryType/IndustryType";
import { LegalForm } from "./pages/admin/handbooks/legalForm/LegalForm";
import { RegisterStatus } from "./pages/admin/handbooks/organic/registerStatus/RegisterStatus";
import { Seasonality } from "./pages/admin/handbooks/organic/seasonality/Seasonality";
import { Checkpoint } from "./pages/admin/handbooks/organic/checkpoint/Checkpoint";
import { GrossProductCollection } from "./pages/admin/organic/grossProductCollection/GrossProductCollection";
import { TheNeedsOfThePopulation } from "./pages/admin/organic/theNeedsOfThePopulation/theNeedsOfThePopulation";
import { Organicproducers } from "./pages/admin/organic/Organicproducers/Organicproducers";
import { Storage } from "./pages/admin/organic/storage/Storage";
import { ProcessingCompanies } from "./pages/admin/organic/Processingcompanies/ProcessingCompanies";
import { FarmCategory } from "./pages/admin/handbooks/organic/farmCategory/FarmCategory";
import { RawMaterial } from "./pages/admin/handbooks/organic/rawMaterial/RawMaterial";
import { ProcessingCapacity } from "./pages/admin/organic/processingCapacity/ProcessingCapacity";
import { ProductionMethods } from "./pages/admin/handbooks/organic/productionMethods/ProductionMethods";
import { StorageTypes } from "./pages/admin/handbooks/organic/storageTypes/StorageTypes";
import { LivestockTradeActivity } from "./pages/admin/organic/livestockTradeActivity/LivestockTradeActivity";
import { AnimalRegister } from "./pages/admin/organic/animalRegister/AnimalRegister";
import { TradeRegistry } from "./pages/admin/organic/tradeRegistry/TradeRegistry";
import { ServiceType } from "./pages/admin/handbooks/organic/serviceType/ServiceType";
import { TransportAccess } from "./pages/admin/handbooks/organic/transportAccess/TransportAccess";
import { LogisticsCenter } from "./pages/admin/organic/logisticsCenter/LogisticsCenter";
import ProcessingcapacitiesPage from './pages/Grossharvestofproductspages/Processingcapacities'
import TreePlusTwoPage from './pages/treePlusTwo'
import GraphPirogPage from './pages/treePlusTwo/graph'
import HeatmapbytypesofproductionPage from './pages/Grossharvestofproductspages/Heatmapbytypesofproduction'
import SummaryDataPage from './pages/treePlusTwo/summaryData'
import AnimalDataPage from './pages/treePlusTwo/animalDataPage'

function App() {
  const { isLoggedIn } = useSelector(getAuthState)
  const dispatch: AppDispatch = useDispatch()

  const setUserInfo = async () => {
	await dispatch(AuthSliceMethods.getUserInfo())
  }

  useEffect(() => {
	if ((!isLoggedIn && localStorage.getItem('token')) || isLoggedIn) {
	  setUserInfo()
	}
  }, [isLoggedIn])

  return (
	<BrowserRouter>
	  <Routes>
		<Route path={ Paths.login } element={ <Login/> }/>
		<Route path={ Paths.changepasswordpage } element={ <ChangePasswordPage/> }/>

		<Route path={ Paths.home } element={ isLoggedIn ? <MainLayout/> : <Login/> }>
		  <Route path={ Paths.home } element={ <Home/> }/>
		  <Route path='*' element={ <NotFoundPage/> }/>

		  <Route path={ Paths.mapAndStatistics } element={ <Reservoir/> }/>
		  <Route path={ Paths.animal } element={ <AnimalPage/> }/>
		  <Route path={ Paths.animalsale } element={ <AnimalSalePage/> }/>
		  <Route path={ Paths.animalkrc } element={ <AnimalKrcPage/> }/>
		  <Route path={ Paths.plantsales } element={ <PlantsSalePage/> }/>
		  <Route path={ Paths.plantsproductions } element={ <PlantsProductionPage/> }/>
		  <Route path={ Paths.nursery } element={ <NurseryPage/> }/>
		  <Route path={ Paths.suppliers } element={ <SuppliersPage/> }/>
		  <Route path={ Paths.breedinplants } element={ <BreedinPlantsPage/> }/>
		  <Route path={ Paths.breedinfarms } element={ <BreedinFarmsPage/> }/>
		  <Route path={ Paths.economicactivity } element={ <EconomicActivityPage/> }/>
		  <Route path={ Paths.camera } element={ <CameraPage/> }/>
		  <Route path={ Paths.generaldata } element={ <GeneralData/> }>
			<Route path='personal/:alias' element={ <PersonalPage/> }/>
			<Route path='movable/:alias' element={ <MovablePage/> }/>
			<Route path='finance/:alias' element={ <FinancePage/> }/>
			<Route path='immovable/:alias' element={ <ImmovablePage/> }/>
		  </Route>
		  <Route path={ Paths.mts } element={ <MTSPage/> }/>
		  <Route path={ Paths.cooperatives } element={ <CooperativesPage/> }/>
		  <Route path={ Paths.tls } element={ <TLSPage/> }/>
		  <Route path={ Paths.agriculturalmachinery } element={ <AgriculturalmachineryPage/> }/>
		  <Route path={ Paths.leasing } element={ <LeasingPage/> }/>
		  <Route path={ Paths.kurultai } element={ <KurultaiPage/> }/>
		  <Route path={ Paths.heatmap } element={ <HeatmapbytypesofanimalsPage/> }/>
		  <Route path={ Paths.heatmapbytypesofproducts } element={ <HeatmapbytypesofproductionPage/> }/>
		  <Route path={ Paths.processingcapacities } element={ <ProcessingcapacitiesPage/> }/>
		  <Route path={ Paths.tlcorganic } element={ <TLCOrganicPage/> }/>
		  <Route path={ Paths.needsofthepopulation } element={ <NeedsofthepopulationPage/> }/>	
		  <Route path={ Paths.storageanalitical } element={ <StorageAnaliticalPage/> }/>	
		  <Route path={ Paths.largeprocessors } element={ <LargeprocessorsPage/> }/>	
		  <Route path={ Paths.importexport } element={ <ImportExportPage/> }/>	
		  {/* <Route path={Paths.chemistryeconomic} element={<ChemistryExonomicPage />} /> */ }
		  <Route path={ Paths.treePlusTwo } element={ <TreePlusTwoPage/> }/>
		  <Route path={ Paths.graphPirog } element={ <GraphPirogPage/> }/>	
		  <Route path={ Paths.summaryData } element={ <SummaryDataPage/> }/>
		  <Route path={ Paths.animalData } element={ <AnimalDataPage/> }/>

		  <Route path={ Paths.chemicalization.pesticidespage } element={ <PesticidesPage/> }/>

		  <Route
			path={ Paths.mineralfertilizersuppliers }
			element={ <Mineralfertilizersupplierspage/> }
		  />
		  <Route path={ Paths.feeding } element={ <FeedingPage/> }/>
		  <Route
			path={ Paths.chemicalization.fertilizationcereals }
			element={ <FertilizationCerealsPage/> }
		  />
		</Route>
		<Route path='/reservoir/statistics/:id' element={ <ReservoirStatisticsWrapper/> }/>
		<Route path={ Paths.allcharts } element={ <AllChartsPage/> }/>

		<Route path={ Paths.home } element={ isLoggedIn ? <Layout/> : <Login/> }>
		  <Route path={ Paths.mainadminpage } element={ <MainAdminPage/> }/>
		  <Route path={ Paths.home } element={ <Home/> }/>
		  <Route path={ Paths.roles } element={ <Roles/> }/>
		  <Route path={ Paths.users } element={ <Users/> }/>
		  <Route path={ Paths.farmowners } element={ <FarmOwners/> }/>
		  <Route path={ Paths.breedingfarms } element={ <BreedingFarms/> }/>
		  <Route path={ Paths.populations } element={ <Population/> }/>
		  <Route path={ Paths.products } element={ <Products/> }/>
		  <Route path={ Paths.reservoirs } element={ <Reservoirs/> }/>
		  <Route path={ Paths.reservoirshistory } element={ <ReservoirsHistory/> }/>
		  <Route path={ Paths.registries.personel } element={ <Personel/> }/>


		  <Route path={ Paths.mechanization.info } element={ <MechanizationInfo/> }/>
		  <Route path={ Paths.mechanization.mts } element={ <Mts/> }/>
		  <Route path={ Paths.mechanization.transport } element={ <TransportRegister/> }/>
		  <Route path={ Paths.registries.realestateregister } element={ <RealEstateRegister/> }/>
		  <Route path={ Paths.mechanization.leasingregister } element={ <LeasingRegister/> }/>
		  <Route path={ Paths.agroculturalcooperative } element={ <AgroculturalCooperative/> }/>
		  <Route path={ Paths.registries.financialindicators } element={ <FinancialIndicators/> }/>
		  <Route path={ Paths.registries.movableProperty } element={ <MovableProperty/> }/>
		  <Route path={ Paths.kurultairegister } element={ <KurultaiRegister/> }/>


		  {/*<Route path={Paths.chemicalization.fertilizer_sypply}  element={<FinancialIndicators />} />*/ }
		  {/*<Route path={Paths.chemicalization.fertilizer_needs}  element={<FertilizerNeeds />} />*/ }
		  {/*<Route path={Paths.chemicalization.fertiliser}  element={<Fertiliser />} />*/ }
		  <Route path={ Paths.chemicalization.company } element={ <Company/> }/>
		  <Route path={ Paths.chemicalization.register_of_pesticides } element={ <Pesticides/> }/>
		  <Route path={ Paths.chemicalization.company_warehouses } element={ <СompanyWarehouses/> }/>
		  <Route path={ Paths.chemicalization.stock } element={ <Stock/> }/>
		  <Route path={ Paths.chemicalization.fertilizer_usage } element={ <FertilizerUsage/> }/>
		  <Route path={ Paths.chemicalization.winterCerealFertilizer } element={ <WinterCerealFertilizer/> }/>

		  <Route path={ Paths.organic.grossproductioncooperative } element={ <GrossProductCollection/> }/>
		  <Route path={ Paths.organic.processingCapacity } element={ <ProcessingCapacity/> }/>
		  <Route path={ Paths.organic.theNeedsOfthePopulation } element={ <TheNeedsOfThePopulation/> }/>
		  <Route path={ Paths.organic.storage } element={ <Storage/> }/>
		  <Route path={ Paths.organic.processingCompaniesadmin } element={ <ProcessingCompanies/> }/>
		  <Route path={ Paths.organic.organicproducers } element={ <Organicproducers/> }/>
		  <Route path={ Paths.organic.livestockTradeActivity } element={ <LivestockTradeActivity/> }/>
		  <Route path={ Paths.organic.animalRegister } element={ <AnimalRegister/> }/>
		  <Route path={ Paths.organic.tradeRegistry } element={ <TradeRegistry/> }/>
		  <Route path={ Paths.organic.logisticsCenter } element={ <LogisticsCenter/> }/>

		  <Route path={ Paths.home }>
			<Route
			  path={ Paths.handbooks.economicactivitytypes }
			  element={ <EconomicActivityTypes/> }
			/>
			<Route path={ Paths.handbooks.leasingoperator } element={ <LeasingOperator/> }/>
			<Route path={ Paths.handbooks.entitytypes } element={ <EntityTypes/> }/>
			<Route path={ Paths.handbooks.leasingproject } element={ <LeasingProject/> }/>

			<Route path={ Paths.handbooks.ownershiptypes } element={ <OwnershipTypes/> }/>
			<Route path={ Paths.handbooks.ownershipforms } element={ <OwnershipForms/> }/>
			<Route
			  path={ Paths.handbooks.realestatelangcategories }
			  element={ <RealEstateLangCategories/> }
			/>
			<Route
			  path={ Paths.handbooks.typeestatepurposeobject }
			  element={ <TypeEstatePurposeObject/> }
			/>
			<Route path={ Paths.handbooks.typeobject } element={ <TypeObjects/> }/>
			<Route path={ Paths.handbooks.realestateconditions } element={ <RealEstateConditions/> }/>

			<Route path={ Paths.handbooks.typetransport } element={ <TypeTransport/> }/>
			<Route path={ Paths.handbooks.transportcategory } element={ <TransportCategory/> }/>
			<Route path={ Paths.handbooks.transportstatus } element={ <TransportStatus/> }/>

			<Route path={ Paths.handbooks.executionStatusType } element={ <ExecutionStatus/> }/>
			<Route path={ Paths.handbooks.questionCategoryType } element={ <QuestionCategory/> }/>

			<Route path={ Paths.handbooks.breedingFarmStatuses } element={ <BreedingFarmStatus/> }/>
			<Route path={ Paths.handbooks.animalbreedfarmtypes } element={ <AnimalBreedFarmTypes/> }/>
			<Route path={ Paths.handbooks.typeanimal } element={ <TypeAnimal/> }/>
			<Route path={ Paths.handbooks.typeproduct } element={ <TypeProduct/> }/>
			<Route path={ Paths.handbooks.animalbreed } element={ <AnimalBreed/> }/>
			<Route path={ Paths.handbooks.direction } element={ <Direction/> }/>

			<Route path={ Paths.handbooks.territorialunits } element={ <TerritorialUnits/> }/>

			<Route path={ Paths.handbooks.positions } element={ <Positions/> }/>
			<Route path={ Paths.handbooks.departments } element={ <Departments/> }/>
			<Route path={ Paths.handbooks.governments } element={ <Governments/> }/>

			<Route path={ Paths.handbooks.unitmeasurement } element={ <UnitMeasurement/> }/>

			<Route
			  path={ Paths.handbooks.filter_fertilizer_category }
			  element={ <FertilizerCategory/> }
			/>
			<Route path={ Paths.handbooks.types_of_fertilizers } element={ <TypesOfFertilizers/> }/>
			<Route path={ Paths.handbooks.typesOfPesticides } element={ <TypesOfPesticides/> }/>
			<Route
			  path={ Paths.handbooks.typesOfAgriculturalCrops }
			  element={ <TypesOfAgriculturalCrops/> }
			/>
			<Route
			  path={ Paths.handbooks.typeOfCategoryProduct }
			  element={ <TypeOfProductCategory/> }
			/>
			<Route path={ Paths.handbooks.generalProductCategory } element={ <GeneralTypeProduct/> }/>
			<Route path={ Paths.handbooks.typeOfProduct } element={ <TypeOfProduct/> }/>
			<Route
			  path={ Paths.handbooks.typeOfVeterinaryCategoryProduct }
			  element={ <VeterinaryProductCategory/> }
			/>
			<Route
			  path={ Paths.handbooks.typeOfVeterinaryProduct }
			  element={ <TypeVeterinaryProduct/> }
			/>
			<Route
			  path={ Paths.handbooks.certificate }
			  element={ <Certificate/> }
			/>
			<Route
			  path={ Paths.handbooks.checkpoint }
			  element={ <Checkpoint/> }
			/>
			<Route
			  path={ Paths.handbooks.industryType }
			  element={ <IndustryType/> }
			/>
			<Route
			  path={ Paths.handbooks.legalForm }
			  element={ <LegalForm/> }
			/>
			<Route
			  path={ Paths.handbooks.registerStatus }
			  element={ <RegisterStatus/> }
			/>
			<Route
			  path={ Paths.handbooks.seasonality }
			  element={ <Seasonality/> }
			/>
			<Route
			  path={ Paths.handbooks.farmCategory }
			  element={ <FarmCategory/> }
			/>
			<Route
			  path={ Paths.handbooks.rawMaterial }
			  element={ <RawMaterial/> }
			/>
			<Route
			  path={ Paths.handbooks.storageTypes }
			  element={ <StorageTypes/> }
			/>
			<Route
			  path={ Paths.handbooks.productionMethods }
			  element={ <ProductionMethods/> }
			/>
			<Route
			  path={ Paths.handbooks.serviceType }
			  element={ <ServiceType/> }
			/>
			<Route
			  path={ Paths.handbooks.transportAccess }
			  element={ <TransportAccess/> }
			/>
		  </Route>
		</Route>
	  </Routes>
	</BrowserRouter>
  )
}

export default App
